// services/ticketService.ts
import axios from "axios";
import { Ticket, BaseTicket, TicketStats, TicketFilters, ApiTicketResponse } from "../types/features/Ticket";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { apiClient } from "../utils/apiClient";

export const ticketService = {
  // Liste paginée des tickets
  async getTickets(
    page: number = 1,
    perPage: number = 20,
    filters?: TicketFilters
  ): Promise<PaginatedResponse<Ticket>> {
    const response = await apiClient.get<PaginatedResponse<Ticket>>('/tickets', {
      params: { page, per_page: perPage, ...filters },
    });

    console.log(response.data)
    return response.data;
  },

  async getTicketById(id: string): Promise<Ticket | null> {
    const response = await apiClient.get<Ticket>(`/tickets/${id}`);
    return response.data;
  },

   async getTicketByReference(ref: string): Promise<Ticket | null> {
    const response = await apiClient.get<ApiTicketResponse>(`/tickets/public/reference/${ref}`);
    return response.data.data;
  },

  async getTicketsByClient(
    clientId: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Ticket>> {
    const response = await apiClient.get<PaginatedResponse<Ticket>>('/tickets', {
      params: { client_id: clientId, page, per_page: perPage },
    });
    return response.data;
  },

  async createTicket(ticket: Omit<Ticket, "id" | "created_at" | "updated_at">): Promise<Ticket> {
    const response = await apiClient.post<Ticket>('/tickets', ticket);
    return response.data;
  },

  async createTicketByPublicForm(payload: any): Promise<ApiTicketResponse> {
    const response = await apiClient.post<ApiTicketResponse>('/tickets/public-form', payload);
    return response.data;
  },

  async updateTicket(id: string, data: Partial<BaseTicket>): Promise<Ticket> {
    const response = await apiClient.put<Ticket>(`/tickets/${id}`, data);
    return response.data;
  },

  async assignAgent(ticketId: string, agentId: string): Promise<Ticket> {
    const response = await apiClient.post<Ticket>(`/tickets/${ticketId}/assign`, { agent_id: agentId });
    return response.data;
  },

  async escalateTicket(ticketId: string): Promise<Ticket> {
    const response = await apiClient.post<Ticket>(`/tickets/${ticketId}/escalate`);
    return response.data;
  },

  async resolveTicket(ticketId: string): Promise<Ticket> {
    const response = await apiClient.post<Ticket>(`/tickets/${ticketId}/resolve`);
    return response.data;
  },

  async recalculatePositions(): Promise<{ success: boolean; message: string; updated: number }> {
    const response = await apiClient.post('/tickets/recalculate-positions');
    return response.data;
  },

  async deleteTicket(id: string): Promise<void> {
    await apiClient.delete(`/tickets/${id}`);
  },

  // Statistiques des tickets
  async getStats(): Promise<TicketStats> {
    const response = await apiClient.get<TicketStats>('/tickets/stats');
    return response.data;
  },
};